import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/PlannedMaintenanceListActions";
import * as api from "../../api/PlannedMaintenanceListApi";
import moment from "moment";
import { showErrorSnackbar, showSuccessSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";

function* getTaskList(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getTaskList(action.payload);
        if (action?.payload?.fromTable) {
            //need to write better logic
            yield put(actions.setTaskList({ data } || undefined));
            yield put(actions.resetTaskList());
        }
        if (action?.payload?.firstCall) {
            yield put(actions.setTaskList({ firstCallRes: data } || undefined));
            yield put(actions.resetTaskList());
        }
        if (action?.payload?.fetchMoreData) {
            console.log(data);
            yield put(actions.setTaskList({ fetchMoreDataRes: data } || undefined));
            yield put(actions.resetTaskList());
        }
        if (action?.payload?.dataHandlerAfterStatusChanged) {
            yield put(actions.setTaskList({ statusChangedRes: data } || undefined));
            yield put(actions.resetTaskList());
        }
        if (action?.payload?.handlePoolData) {
            yield put(actions.setTaskList({ handlePoolDataRes: data } || undefined));
            yield put(actions.resetTaskList());
        }
        if (action?.payload?.handleCheckedMe) {
            yield put(actions.setTaskList({ handleCheckedMeRes: data } || undefined));
            yield put(actions.resetTaskList());
        }
        if (action?.payload?.handleTime) {
            yield put(actions.setTaskList({ handleTimeRes: data } || undefined));
            yield put(actions.resetTaskList());
        }
        if (action?.payload?.applyFilter) {
            yield put(actions.setTaskList({ applyFilterRes: data } || undefined));
            yield put(actions.resetTaskList());
        }
        yield put(actions.setTaskList({ data } || undefined));
        yield put(actions.resetTaskList());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPlannedMaintenanceListMultiple(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getPlannedMaintenanceListMultiple(action.payload);
        if (action?.payload?.dataHandlerAfterStatusChanged) {
            yield put(actions.setPlannedMaintenanceListMultiple({ statusChangedRes: data } || undefined));
        }
        if (action?.payload?.fetchMoreData) {
            yield put(actions.setPlannedMaintenanceListMultiple({ fetchMoreDataRes: data } || undefined));
        }
        if (action?.payload?.applyFilterRes) {
            yield put(actions.setPlannedMaintenanceListMultiple({ applyFilterRes: data } || undefined));
        }
        if (action?.payload?.handleStatusRes) {
            yield put(actions.setPlannedMaintenanceListMultiple({ handleStatusRes: data } || undefined));
        }
        if (action?.payload?.handlePoolRes) {
            yield put(actions.setPlannedMaintenanceListMultiple({ handlePoolRes: data } || undefined));
        }
        if (action?.payload?.handleAssignMe) {
            yield put(actions.setPlannedMaintenanceListMultiple({ handleAssignMe: data } || undefined));
        }
        if (action?.payload?.firstCall) {
            yield put(actions.setPlannedMaintenanceListMultiple({ firstCallRes: data } || undefined));
        }
        if (action?.payload?.applyRefreshRes) {
            console.log("refresh res saga");
            yield put(actions.setPlannedMaintenanceListMultiple({ applyRefreshRes: data } || undefined));
        }
    } catch (error) {
        yield put(actions.setPlannedMaintenanceListMultiple(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* downloadExcelFile(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.downloadExcelFile(action.payload);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        const filename = "MOST_PlannedMaintenanceTasks_" + moment(new Date()).format("DD_MM_YYYY_HH_mm_ss") + ".xlsx"; //name with date time & extension
        link.setAttribute("download", filename); //or any other extension
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getList(action) {
    try {
        const { data } = yield api.getList(action.payload);
        yield put(actions.setList(data || undefined));
        yield put(actions.resetList());
    } catch (error) {
        yield put(actions.setList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getStatusList(action) {
    try {
        const { data } = yield api.getStatusList(action.payload);
        yield put(actions.setStatusList(data || undefined));
        yield put(actions.resetStatusList());
    } catch (error) {
        yield put(actions.setStatusList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getAreaList() {
    try {
        const { data } = yield api.getAreaList();
        yield put(actions.setAreaList(data || undefined));
        yield put(actions.resetAreaList());
    } catch (error) {
        yield put(actions.setAreaList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getTechnicianList(action) {
    try {
        const { data } = yield api.getTechnicianList();
        if (action?.payload?.handleChecked) {
            yield put(actions.setTechnicianList({ handleCheckedRes: data } || undefined));
            yield put(actions.resetTechnicianList());
        } else {
            yield put(actions.setTechnicianList(data || undefined));
            yield put(actions.resetTechnicianList());
        }
    } catch (error) {
        yield put(actions.setTechnicianList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getCostCenterList() {
    try {
        const { data } = yield api.getCostCenterList();
        yield put(actions.setCostCenterList(data || undefined));
        yield put(actions.resetCostCenterList());
    } catch (error) {
        yield put(actions.setCostCenterList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getMaintenanceTypeList() {
    try {
        const { data } = yield api.getMaintenanceTypeList();
        yield put(actions.setMaintenanceTypeList(data || undefined));
    } catch (error) {
        yield put(actions.setMaintenanceTypeList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getMainListByAreaID(action) {
    try {
        const { data } = yield api.getMainListByAreaID(action.payload);
        yield put(actions.setMainListByAreaID(data || undefined));
        yield put(actions.resetMainListByAreaID());
    } catch (error) {
        yield put(actions.setMainListByAreaID(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getSubListById(action) {
    try {
        const { data } = yield api.getSubListById(action.payload);
        yield put(actions.setSubListById(data || undefined));
        yield put(actions.resetSubListById());
    } catch (error) {
        yield put(actions.setSubListById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* closeManyPlannedTasks(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.closeManyPlannedTasks(action.payload);
        showSuccessSnackbar(data.message);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPoolByAssignedUser(action) {
    try {
        const { data } = yield api.getPoolByAssignedUser(action.payload);
        yield put(actions.setPoolByAssignedUser(data || undefined));
    } catch (error) {
        yield put(actions.setPoolByAssignedUser(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_TASKS_LIST_FOR_PLANNED_MAINTENANCE_LIST, getTaskList);
    yield takeEvery(actions.Types.GET_PLANNED_MAINTENANCE_MULTIPLE, getPlannedMaintenanceListMultiple);
    yield takeEvery(actions.Types.GET_EXCEL_FILE, downloadExcelFile);
    yield takeEvery(actions.Types.GET_POOL_LIST_FOR_PLANNED_MAINTENANCE_LIST, getList);
    yield takeEvery(actions.Types.GET_STATUS_LIST_FOR_PLANNED_MAINTENANCE_LIST, getStatusList);
    yield takeEvery(actions.Types.GET_AREA_LIST_FOR_PLANNED_MAINTENANCE_LIST, getAreaList);
    yield takeEvery(actions.Types.GET_TECHNICIAN_LIST_FOR_PLANNED_MAINTENANCE_LIST, getTechnicianList);
    yield takeEvery(actions.Types.GET_COST_CENTER_LIST_FOR_PLANNED_MAINTENANCE_LIST, getCostCenterList);
    yield takeEvery(actions.Types.GET_MAINTENANCE_TYPE_LIST, getMaintenanceTypeList);
    yield takeEvery(actions.Types.GET_MAIN_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST, getMainListByAreaID);
    yield takeEvery(actions.Types.GET_SUB_LIST_BY_AREA_ID_FOR_PLANNED_MAINTENANCE_LIST, getSubListById);
    yield takeEvery(actions.Types.GET_POOL_LIST_BY_ASSIGNED_USER, getPoolByAssignedUser);
    yield takeEvery(actions.Types.CLOSE_MANY_PLANNED_TASKS, closeManyPlannedTasks);
}

const PlannedMaintenanceListSaga = [fork(watchAll)];

export default PlannedMaintenanceListSaga;
